import { useTranslation } from 'react-i18next';
import PaymentLastPageSingleComponent from '../payment_flow/paymentLastPageSingleComponent';
import { constants } from '../constants/constants';
import PayerDetailsSummary from '../payment_flow/payerDetailsSummary';
import UpComingMonths from './upComingMonths';
import React from 'react';

export function OrderStatusDetails(props) {

  const { t } = useTranslation();
  const {
    paymentDetails,
    tenantDetails,
    buildingPayerDetails,
    oneTimePaymentsInstallments,
    pastPaymentsInstallments,
    onGoingInstallments,
    nextMonthsPaymentsData,
    tenantCommission,
    onChange,
    isExpense,
  } = props;


  const payerDetails = isExpense ? buildingPayerDetails : tenantDetails;

  const selectNameFn = constants.cache.keys.payments.oneTimeInstallmentsName;

  return (
    <div className="order-status-details">

      <div className="row set_RoW_1 pt-5 row-last-page-before-cc row-order-status">
        {/* ignoreMaxInstallments should only be at the status page to ground debt payments
            in case the max a has decreased after the user already paid */}
        <PaymentLastPageSingleComponent
          title={t('payments.pay_debt')}
          settings={pastPaymentsInstallments}
          typeOfPayment={constants.cache.keys.payments.pastPayments}
          onChange={onChange}
          hideSelectInstallments={true}
          ignoreCache={true}
          hideUnsuccessful={true}
          ignoreMaxInstallments={true}
          isExpense={isExpense}
        />
        <PaymentLastPageSingleComponent
          title={t('payments.on_going_title')}
          settings={onGoingInstallments}
          typeOfPayment={constants.cache.keys.payments.onGoingPayments}
          onChange={onChange}
          hideSelectInstallments={true}
          ignoreCache={true}
          hideUnsuccessful={true}
          ignoreMaxInstallments={true}
          isExpense={isExpense}
        />
        {oneTimePaymentsInstallments
          .map((payment, index) => ({ payment, index, selectName: selectNameFn(payment.building_one_time_payment_id) }))
          .map(({ payment, index, selectName }) => (
            <PaymentLastPageSingleComponent
              title={isExpense ? t('payments.pay_expense') : null}
              settings={payment}
              typeOfPayment={selectName}
              onChange={onChange}
              hideSelectInstallments={true}
              ignoreCache={true}
              hideUnsuccessful={true}
              ignoreMaxInstallments={true}
              key={index}
              isOneTimePayment={true}
              isExpense={isExpense}
            />
          ))
        }
      </div>

      <div className="container">
        <PayerDetailsSummary
          payerDetails={payerDetails}
        />
      </div>

      <UpComingMonths
        paymentDetails={paymentDetails}
        nextMonthsPaymentsData={nextMonthsPaymentsData}
        tenantCommission={tenantCommission}
        isStatusPage = {true}
      />
    </div>
  )
}
